<script>
  export default {
    name: "",
    props: {
      form: {
        type: Object,
      },
      cashes: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        types_: [
          {value: 1, label: 'Напечатать'},
          {value: 2, label: 'Отправить Email'},
          {value: 3, label: 'Отправить SMS'},
          {value: 4, label: 'Напечатать и отправить Email'},
          {value: 5, label: 'Напечатать и отправить SMS'},
        ],
      }
    },
    methods: {
      change_cash() {
        if (this.form.BillProvideTypeId !== 1) return;
        this.$nextTick(() => {
          if (this.cash && !this.cash.Capabilities.CanPrintPaperReceipt) {
            this.form.BillProvideTypeId = 2;
          }
        });
      },
    },
    computed: {
      types() {
        if (this.cash && !this.cash.Capabilities.CanPrintPaperReceipt) {
          return (this.types_ || []).filter(i => i.value !== 1 && i.value !== 4 && i.value !== 5);
        }
        return this.types_;
      },
      cash() {
        return (this.cashes || []).find(i => i.Id === this.form.OnlineCashId);
      }
    },
    watch: {
    },
    components: {},
    mounted() {
      this.change_cash();
    },
    destroyed() {
    },
  }
</script>
<template>
  <el-form class="online-cashes-form" v-if="form">
    <el-form-item label="Онлайн касса">
      <el-select
        v-model="form.OnlineCashId"
        :disabled="cashes.length===1"
        @change="change_cash"
      >
        <el-option
          v-for="item in cashes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Тип предоставления чека">
      <el-select
        v-model="form.BillProvideTypeId"
      >
        <el-option
          v-for="item in types"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>
<style lang="scss">
  .online-cashes-form {
    .el-select{
      width: 100%;
    }
    .el-input {
      .el-input__inner {
        color: #606266;
        background-color: #ffffff;
      }
    }
  }
</style>
